function displayCards(limit) {
	if (limit == 8) {
		Array.from(postCards).forEach((e, i) =>
		i >= (postPage - 1) * limit && i < postPage * limit
			? (e.style.display = "flex")
			: (e.style.display = "none")
	);
	} else {
		Array.from(postCards).forEach((e, i) =>
		i >= (postPage - 1) * limit && i < postPage * limit
			? (e.style.display = "block")
			: (e.style.display = "none")
	);
	}	
}
